/**
 * Entry Type Selector Component
 *
 * Dropdown for selecting entry type with icons.
 */

import type { EntryType } from '@/types/entry';
import { ENTRY_TYPE_ICONS, ENTRY_TYPE_LABELS } from '@/types/entry';

interface EntryTypeSelectorProps {
  value: EntryType | string;
  onChange: (value: EntryType) => void;
  className?: string;
}

const ENTRY_TYPES: EntryType[] = [
  'conversation',
  'meeting',
  'journal',
  'check_in',
  'voice_memo',
  'brainstorm',
  'call',
  'email',
  'message',
];

export function EntryTypeSelector({
  value,
  onChange,
  className = '',
}: EntryTypeSelectorProps) {
  return (
    <div className={className}>
      <label className="block text-sm font-medium text-gray-700 mb-1">
        Entry Type
      </label>
      <div className="relative">
        <select
          value={value}
          onChange={(e) => onChange(e.target.value as EntryType)}
          className="w-full appearance-none bg-white border border-gray-300 rounded-lg px-4 py-2.5 pr-10 focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500 outline-none"
        >
          {ENTRY_TYPES.map((type) => (
            <option key={type} value={type}>
              {ENTRY_TYPE_ICONS[type]} {ENTRY_TYPE_LABELS[type]}
            </option>
          ))}
        </select>
        <div className="absolute right-3 top-1/2 -translate-y-1/2 pointer-events-none text-gray-400">
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M19 9l-7 7-7-7" />
          </svg>
        </div>
      </div>
      <p className="mt-1 text-xs text-gray-500">
        Current: {ENTRY_TYPE_ICONS[value as EntryType] || '📄'} {ENTRY_TYPE_LABELS[value as EntryType] || value}
      </p>
    </div>
  );
}

